import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {AurDataGridFilterState} from '../../components/common/aur-data-grid-pro/useServerSideDataGrid';
import {ProjectViewColumnState} from '../../components/pages/welcome-screen-multi-client/project-view/ProjectViewColumnState';
import {logoutAction} from '../rootAction';

export type State = {
  projectViewTableState?: AurDataGridFilterState | null;
  projectViewColumnState?: ProjectViewColumnState | null;
};

const initialState: State = {
  projectViewTableState: null,
  projectViewColumnState: null,
};

const welcomeScreenProjectViewSlice = createSlice({
  name: 'welcomeScreenProjectViewSlice',
  initialState: initialState,
  reducers: {
    setProjectViewTableState: (
      state,
      action: PayloadAction<AurDataGridFilterState | null | undefined>
    ) => {
      state.projectViewTableState = action.payload;
    },
    setProjectViewColumnState: (
      state,
      action: PayloadAction<ProjectViewColumnState | null | undefined>
    ) => {
      state.projectViewColumnState = action.payload;
    },
    resetPageState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logoutAction, () => {
      return initialState;
    });
  },
});

export const {
  setProjectViewTableState,
  setProjectViewColumnState,
  resetPageState,
} = welcomeScreenProjectViewSlice.actions;

export const welcomeScreenProjectViewInitialState = initialState;
export default welcomeScreenProjectViewSlice.reducer;
